import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 0
  },
  label: {
    lineHeight: '12px'
  },
  value: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    maxWidth: '100%',
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colorPalette.green_80
  }
}));

export default useStyles;
